var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.toRoute}},[_c('v-btn',{staticClass:"mb-4 ml-0 mr-3 add-button",attrs:{"color":"green","dark":""}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-plus")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }